import React from 'react';
import {
    Grid,
    FormControlLabel,
    Checkbox,
    FormLabel,
    TextField
} from '@mui/material';

interface Respostas {
    requerRefrigeracao: String;
    jaFoiUsado: String;
    foiDevolvido: String;
    defeitoDetectado: String;
    armazenadoCorretamente: String;
    conducoesArmazenamentoOutrosDetalhes: String;
}

interface ArmazenamentoProps {
    Respostas: Respostas;
    handleResposta: (key: string, valor: string) => void;
    handleOutrosResposta: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ArmazenamentoSituacao: React.FC<ArmazenamentoProps> = ({
    Respostas, handleResposta, handleOutrosResposta
}) => {

    // const [outrosDetalhes, setOutrosDetalhes] = useState('');

    return (
        <Grid container spacing={2} style={{ margin: '0 10px' }}>
            <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} sm={6}>
                    <FormLabel>O Produto  requer refrigeração?</FormLabel>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="requerRefrigeracao"
                                checked={Respostas.requerRefrigeracao === 'Sim'}
                                onChange={() => handleResposta('requerRefrigeracao', 'Sim')}
                            />
                        }
                        label="Sim"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="requerRefrigeracao"
                                checked={Respostas.requerRefrigeracao === 'Não'}
                                onChange={() => handleResposta('requerRefrigeracao', 'Não')}
                            />
                        }
                        label="Não"
                    />
                </Grid>
            </Grid>

            <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} sm={6}>
                    <FormLabel>O produto já foi usado na unidade sanitária?</FormLabel>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="jaFoiUsado"
                                checked={Respostas.jaFoiUsado === 'Sim'}
                                onChange={() => handleResposta('jaFoiUsado', 'Sim')}
                            />
                        }
                        label="Sim"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="jaFoiUsado"
                                checked={Respostas.jaFoiUsado === 'Não'}
                                onChange={() => handleResposta('jaFoiUsado', 'Não')}
                            />
                        }
                        label="Não"
                    />
                </Grid>
            </Grid>

            <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} sm={6}>
                    <FormLabel>oproduto foi entregue e devolvido pelo cliente/paciente?</FormLabel>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="foiDevolvido"
                                checked={Respostas.foiDevolvido === 'Sim'}
                                onChange={() => handleResposta('foiDevolvido', 'Sim')}
                            />
                        }
                        label="Sim"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="foiDevolvido"
                                checked={Respostas.foiDevolvido === 'Não'}
                                onChange={() => handleResposta('foiDevolvido', 'Não')}
                            />
                        }
                        label="Não"
                    />
                </Grid>
            </Grid>

            <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} sm={6}>
                    <FormLabel>O defeito foi detectado pela unidade sanitária?</FormLabel>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="defeitoDetectado"
                                checked={Respostas.defeitoDetectado === 'Sim'}
                                onChange={() => handleResposta('defeitoDetectado', 'Sim')}
                            />
                        }
                        label="Sim"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="defeitoDetectado"
                                checked={Respostas.defeitoDetectado === 'Não'}
                                onChange={() => handleResposta('defeitoDetectado', 'Não')}
                            />
                        }
                        label="Não"
                    />
                </Grid>
            </Grid>

            <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} sm={6}>
                    <FormLabel>O Produto está armazenado de acordo com as Boas Práticas de Armazenamento?</FormLabel>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="armazenadoCorretamente"
                                checked={Respostas.armazenadoCorretamente === 'Sim'}
                                onChange={() => handleResposta('armazenadoCorretamente', 'Sim')}
                            />
                        }
                        label="Sim"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="armazenadoCorretamente"
                                checked={Respostas.armazenadoCorretamente === 'Não'}
                                onChange={() => handleResposta('armazenadoCorretamente', 'Não')}
                            />
                        }
                        label="Não"
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1} alignItems="center">
                <TextField
                    label="Outros (especifique)"
                    name="conducoesArmazenamentoOutrosDetalhes"
                    multiline
                    fullWidth
                    size="small"
                    value={Respostas.conducoesArmazenamentoOutrosDetalhes}
                    onChange={handleOutrosResposta}
                    sx={{ mt: 1 }}
                />
            </Grid>
        </Grid>
    )
}

export default ArmazenamentoSituacao
